
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/docusaurus",
      function () {
        return require("private-next-pages/integrations/docusaurus.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/docusaurus"])
      });
    }
  